module.exports = __webpack_public_path__ + "img/draw_300.af085807.jpg";